import { type PropsWithChildren } from 'react';
import { SelectedStylepackContext } from './stylepack-context';
import type { Stylepack } from '@/types/stylepacks.types';

export default function StylepackProvider(props: PropsWithChildren<{ selectedStylepack: Stylepack }>) {
  return (
    <SelectedStylepackContext.Provider value={{ stylepack: props.selectedStylepack }}>
      {props.children}
    </SelectedStylepackContext.Provider>
  );
}
